import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import user from "./modules/user";
import dict from "./modules/dict";
import bussiness from "./modules/bussiness";

import getters from "./getters";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    user,
    dict,
    bussiness,
  },
  getters,
});
